import React, { useState } from "react";

import ChartLegend from "../../common/ChartLegend";
import DoughnutChart from "../../common/DoughnutChart";

import lbl from "../../../data/Labels.json";
import { formatPrintAmount } from "../financePrintUtils";

const Chart = ({ data }) => {
  const chartData = [
    {
      label: lbl.Present,
      value: data?.present_count || 0,
      percent: data?.present_percentage || 0,
      color: "#48C29D",
    },
    {
      label: lbl.Absent,
      value: data?.absent_count || 0,
      percent: data?.absent_percentage || 0,
      color: "#9A3859",
    },
    {
      label: lbl.Substitute,
      value: data?.substitute_count || 0,
      percent: data?.substitute_percentage || 0,
      color: "#8CAA72",
    },
    {
      label: lbl.Holiday,
      value: data?.holiday_count || 0,
      percent: data?.holiday_percentage || 0,
      color: "#EF9C0E",
    },
  ];

  return data ? (
    <div style={{margin: "10px", justifyContent: "center" , justifyItems: "center" }}>
      <div className="sub-title" style={{display: "flex", gap: "5px", justifyContent: "center", margin: "10px" }}>
        <p style={{color: "var(--blue)"}}>{data?.end_date}</p>
        <p>{lbl.To}</p>
        <p style={{color: "var(--blue)"}}>{data?.start_date}</p>
        <p>{lbl.From}</p>
        <p style={{color: "var(--blue)"}}>{data?.entry_year}</p>
      </div>
      <div style={{display:"grid", gridTemplateColumns:"40% 60%"}}>
        <div className="report-order-list " style={{display: "grid", placeItems: "center"}}>
          <ol>
            <li>
              <b>{`$ ${formatPrintAmount(data?.salary_per_hour)}`}</b>
              <span>{lbl.SalaryPeHour}</span>
            </li>
            <li>
              <b>{`$ ${formatPrintAmount(data?.total_benefit)}`}</b>
              <span>{lbl.TotalBenefits}</span>
            </li>
            <li>
              <b>{`$ ${formatPrintAmount(data?.salary_before_tax)}`}</b>
              <span>{lbl.SalaryBeforeTax}</span>
            </li>
            <li>
              <b>{`$ ${formatPrintAmount(data?.salary_tax)}`}</b>
              <span>{lbl.Tax}</span>
            </li>
            <li>
              <b>{`$ ${formatPrintAmount(data?.payable)}`}</b>
              <span>{lbl.Payable}</span>
            </li>
            <li>
              <b>{`$ ${formatPrintAmount(data?.paid)}`}</b>
              <span>{lbl.Paid}</span>
            </li>
            <li>
              <b>{`$ ${formatPrintAmount(data?.half_year_balance)}`}</b>
              <span>{lbl.Balance}</span>
            </li>
          </ol>
        </div>
        <div className="print-doughnut-chart-panel" style={{
          display:"grid", 
          gridTemplateColumns:"70% 30%",
          backgroundColor: "#f8f8f8",
          borderRadius: "10px",
          padding: "15px"
        }}>
          <div className="chart-legend">
            <ChartLegend data={chartData} />
          </div>
          <div className="chart">
            <DoughnutChart data={chartData} />
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default Chart;
